import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  searchSection: {
    marginBottom: "40px",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.palette.primary,
  },
  tableContainer: {
    boxShadow: "0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)",
  },
  table: {
    minWidth: 650,
  },
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    boxShadow: "0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15)",
    [theme.breakpoints.up(800 + theme.spacing(3) * 2)]: {
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "50ch",
  },
  queryField: {
    width: "400px",
  },
  button: {
    marginLeft: theme.spacing(1),
  },
  bulkOperations: {
    position: "relative",
  },
  bulkActions: {
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 10,
    marginTop: 6,
    position: "absolute",
    width: "100%",
    height: 60,
    zIndex: 2,
    backgroundColor: theme.palette.background.default,
  },
  bulkAction: {
    marginLeft: theme.spacing(2),
  },
}));
